
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/team-roles",
      function () {
        return require("private-next-pages/docs/team-roles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/team-roles"])
      });
    }
  